// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GnMv","col":"styles_col__U3fY1"};